import script from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=887136bc&lang=css"

const __exports__ = script;

export default __exports__